import { render, staticRenderFns } from "./HomePageFAQ.vue?vue&type=template&id=6805f78c&scoped=true&"
import script from "./HomePageFAQ.vue?vue&type=script&lang=js&"
export * from "./HomePageFAQ.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFAQ.vue?vue&type=style&index=0&id=6805f78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805f78c",
  null
  
)

export default component.exports